// Seller phone masking (seller-rules batch). The Worker redacts seller
// phone numbers for viewers without access (see api middleware/snakeCase.ts
// + lib/phoneMask.ts) by replacing digits with U+2022 bullets, e.g.
// '+43 ••• ••01'. The frontend must treat such values as display-only:
// no tel: links, no editing, no write-back (backend additionally rejects
// masked values with 400 masked_phone_rejected).
export const PHONE_MASK_CHAR = '•'; // •

/** True when the value is a masked phone string coming from the API. */
export function isMaskedPhoneClient(v: unknown): boolean {
  return typeof v === 'string' && v.includes(PHONE_MASK_CHAR);
}
